/* unplugin-vue-components disabled */import { render } from "./Head.vue?vue&type=template&id=f5aedfe6&scoped=true"
import script from "./Head.vue?vue&type=script&lang=js"
export * from "./Head.vue?vue&type=script&lang=js"

import "./Head.vue?vue&type=style&index=0&id=f5aedfe6&lang=scss&scoped=true"
import "./Head.vue?vue&type=style&index=1&id=f5aedfe6&lang=scss"

import exportComponent from "/root/.jenkins/workspace/高保障-门户哈尔滨医科大学-前端页面-saas/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5aedfe6"]])

export default __exports__